/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import defaultImage from "../../../src/Assets/fallbackimg_giftcard.png";
import pointiconImage from "../../../src/Assets/point_icon.svg";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { onGetOrder } from "../../Store/Slices/orderSlice";
import BackSections from "../Giftcards/BackSections";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../Components/Loader/Loader";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import {
  ClientConfigurationData,
  Dispatch,
  formatPrice,
  getImageUrl,
  LoginV3Data,
  OrderData,
  trackEvent,
  useClientConfigValue,
  useGaTrackingConfig,
  V3Data,
} from "../Utility/Utility";
import { onSaveDenoCard } from "../../Store/Slices/cardDataSlice";
import BackToTopButton from "../BackToTopButton/BackToTopButton";
import axiosInstanceClient from "../../Common/Axios/axiosInstanceClient";
import {
  getPointEarnStatus,
  getPointsRedeemStatus,
  isRewardStatusNotApplicable,
} from "../Utility/rewardStatus";

const isEnabledConfigValue = (value) =>
  value === true ||
  value === 1 ||
  ["1", "true", "active"].includes(String(value ?? "").trim().toLowerCase());

const RetrieveCode = () => {
  const navigate = useNavigate();
  const dispatch = Dispatch();
  const userOrderData = OrderData();
  const v3Data = V3Data();
  const translation = getTranslationData();
  const v3LoginData = LoginV3Data();
  const isLogin = sessionStorage.getItem("login");

  const loaderRef = useRef(null);
  const [hasMore, setHasMore] = useState(true);
  const [isOptEnable, setIsOptEnable] = useState();
  const [showError, setShowError] = useState(false);
  const [loadingCardKey, setLoadingCardKey] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  const [userOrdersList, setUserOrderList] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const clientConfig = ClientConfigurationData();
  const loginTokenData = v3LoginData?.memberProfile;
  const [openInst, setOpenInst] = useState(true);
  const clientConfigurationData = useSelector(
    (state) => state.clientConfigurationReducer.clientConfigurationData?.[0],
  );
  const { gaAffiliation } = useGaTrackingConfig();
  const clientDataReducer = useSelector((state) => state.clientDataReducer);
  const clientConfigurations =
    clientDataReducer?.clientData?.clientConfigurations;
  const earnLabelConfig =
    clientConfig?.clientConfig?.find(
      (item) =>
        String(item?.configKey ?? "").trim().toLowerCase() ===
        "isearnlabelshowonly",
    )?.configValue ??
    clientConfig?.isEarnLabelShowOnly ??
    clientConfigurations?.find(
      (item) =>
        String(item?.configKey ?? "").trim().toLowerCase() ===
        "isearnlabelshowonly",
    )?.configValue;
  const journeyType = clientDataReducer?.clientData?.journeyType;
  const isWalletJourney =
    journeyType === true ||
    journeyType === 1 ||
    String(journeyType).trim().toLowerCase() === "true" ||
    String(journeyType).trim() === "1";
  const showEarnLabelOnly =
    isEnabledConfigValue(earnLabelConfig) && !isWalletJourney;

  // Link to the previous platform's orders; the banner is shown only when this is configured.
  const olderOrdersUrlConfig = useClientConfigValue("olderOrdersRedirectUrl");
  const olderOrdersRedirectUrl = ["", "null", "undefined"].includes(
    olderOrdersUrlConfig.toLowerCase(),
  )
    ? null
    : olderOrdersUrlConfig;

  const hasContactMessage = !["", "null", "undefined"].includes(
    String(translation?.detailsSentRegisteredContact ?? "").trim().toLowerCase(),
  );

  useEffect(() => {
    if (userOrderData?.orderData?.totalCount && userOrdersList) {
      setHasMore(userOrdersList.length < userOrderData?.orderData?.totalCount);
    }
  }, [userOrdersList]);

  useEffect(() => {
    if (!userOrderData?.isLoading && userOrderData?.orderData?.orders) {
      const orders = userOrderData?.orderData?.orders || [];
      if (pageNumber === 1) {
        setUserOrderList(orders);
      } else {
        setUserOrderList((prev) => [...(prev || []), ...orders]);
      }
    }
  }, [userOrderData, userOrderData?.isLoading]);

  useEffect(() => {
    setIsOptEnable(clientConfigurationData?.otpRedeem);
  }, [clientConfigurationData]);

  useEffect(() => {
    !isLogin && setShowError(true);
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    getOrderListApiCall();
    trackEvent("page_browse", {
      page_title: "order history",
      page_url: window.location.href,
    });
  }, []);

  // Infinite scroll page increment
  useEffect(() => {
    if (pageNumber > 1) {
      getOrderListApiCall();
    }
  }, [pageNumber]);

  // IntersectionObserver for infinite scroll
  useEffect(() => {
    if (!hasMore) return;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setPageNumber((prev) => prev + 1);
        }
      },
      {
        root: null,
        rootMargin: "300px",
        threshold: 0.1,
      },
    );

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
      observer.disconnect();
    };
  }, [hasMore, userOrdersList]);

  const getOrderListApiCall = () => {
    const request = {
      memberId: v3LoginData.memberIdentifier,
      pageNumber: pageNumber,
      pageSize: 12,
    };
    dispatch(onGetOrder(request));
  };

  const dateFormat = (dateString) => {
    const date = new Date(dateString);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-GB", options)?.replace(",", "");
  };

  const getResendSuccessMessage = () => {
    const hasEmail = !!v3LoginData?.memberProfile?.emailId;
    const hasMobile = !!loginTokenData?.mobileNumber;
    if (hasEmail && hasMobile) {
      return (
        translation?.Voucher_code_resent_registered_email_and_mobile_number ||
        "Voucher code sent to your registered email and mobile number."
      );
    } else if (hasMobile) {
      return (
        translation?.Voucher_code_resent_registered_mobile_number ||
        "Voucher code sent to your registered mobile number."
      );
    } else if (hasEmail) {
      return (
        translation?.Voucher_code_resent_registered_email ||
        "Voucher code sent to your registered email."
      );
    }
    return "Voucher code resent successfully.";
  };

  const handleResendFail = (errorMessage) => {
    toast.error(
      errorMessage ||
      translation?.UnableToResendTheCode ||
      "Unable to resend the voucher code due to a technical issue. Please try again later.",
    );
    setLoadingCardKey(null);
  };

  /**
   * Calls the backend API to resend order communication (email + SMS).
   * @param {string} orderId - The order ID
   * @param {number} denomination - The denomination to resend for
   */
  const resendCodeViaApi = async (orderId, denomination) => {
    try {
      const response = await axiosInstanceClient.post(
        `/resend-communication?orderId=${orderId}&denomination=${denomination}`,
      );

      const result = response?.data;
      if (
        result?.httpStatusCode === "200" ||
        result?.errorCode === "200"
      ) {
        toast.success(getResendSuccessMessage());
      } else {
        handleResendFail(result?.errorMessage);
      }
    } catch (error) {
      console.error("Resend communication API error:", error);
      handleResendFail(
        error?.response?.data?.errorMessage || null,
      );
    } finally {
      setLoadingCardKey(null);
    }
  };

  const getProductIdentifier = (product) => product?.productId ?? product?.id;

  const handleRetrieveCode = (productData, order, cardKey, actionType) => {
    const resolvedProductId = getProductIdentifier(productData);
    const updatedProductData = {
      ...productData,
      productId: resolvedProductId,
    };

    dispatch(
      onSaveDenoCard({
        productData: updatedProductData,
        orderId: order.orderId,
      }),
    );

    if (actionType === "GET") {
      // GET CODE — navigate to OTP or order-detail page
      isOptEnable
        ? navigate("/otp", {
          state: {
            orderId: order?.orderId,
            denomination: updatedProductData?.denomination,
            productId: updatedProductData?.productId,
          },
        })
        : navigate("/order-detail", {
          state: {
            orderId: order?.orderId,
            denomination: updatedProductData?.denomination,
            productId: updatedProductData?.productId,
          },
        });
    }

    if (actionType === "RESEND") {
      // RESEND CODE — call backend API to send email + SMS
      const hasEmail = !!v3LoginData?.memberProfile?.emailId;
      const hasMobile = !!loginTokenData?.mobileNumber;
      if (!hasEmail && !hasMobile) {
        toast.error(
          translation?.UnableToResendTheCode ||
          "Unable to resend the voucher code due to a technical issue. Please try again later.",
        );
        return;
      }

      setLoadingCardKey(cardKey);
      resendCodeViaApi(order.orderId, updatedProductData.denomination);
    }

    trackEvent("coupon_redeem", {
      currency: "INR",
      value: order?.amount,
      discount:
        order?.products?.reduce((sum, item) => {
          const discountAmount =
            (item.denomination * (item.customerDis || 0)) / 100;
          return sum + discountAmount;
        }, 0) || 0,
      gift_card_value: order.products?.reduce(
        (sum, item) => sum + item.denomination * item.qty,
        0,
      ),
      items: order.products?.map((item) => ({
        id: order?.id,
        item_id: item?.sku,
        item_name: item?.name,
        item_brand: item?.name,
        item_category: "Giftcards",
        affiliation: gaAffiliation,
        item_category2: order?.category,
        item_image: getImageUrl(item?.image) || defaultImage,
        item_url: window.location.href,
        price: Math.floor(item?.denomination * (1 - item?.customerDis / 100)),
        quantity: item?.qty,
        gift_card_points: item?.denomination,
        expiry_date: order?.expireDate,
      })),
    });
  };

  const handleLogin = () => {
    window.open(v3Data?.SignInUrl, "_self");
  };

  const handleClick = () => {
    const prevRoute = sessionStorage.getItem("PREV_ROUTE");
    if (prevRoute === "/order-confirmation" || prevRoute === "/order-detail") {
      navigate("/", { replace: true });
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <ToastContainer />
      <BackToTopButton />
      {showError ? (
        handleLogin()
      ) : (
        <>
          {userOrderData.isLoading && pageNumber === 1 ? (
            <Loader />
          ) : (
            <div className="bg light_bg_white">
              <BackSections />
              {clientDataReducer?.otpConfig === 2 && isMobile ? (
                <div className="order-bottom trend-mb m-3">
                  {translation?.detailsSentRegistered}
                  <div className="mt-1">{translation?.mobileEmail}</div>
                </div>
              ) : (
                <>
                  <section
                    className={`order_title_section ${hasContactMessage ? "" : "order_title_section--no-msg"}`}
                  >
                    <div className="container">
                      <div className="row justify-content-center">
                        <div className="gift-head">
                          <h2>
                            <span
                              onClick={handleClick}
                              className="showDesktopOnly changeCursor"
                            >
                              <i className="fa-solid fa-chevron-left clr-black-blk"></i>{" "}
                              &nbsp;
                            </span>
                            {translation?.orders}
                          </h2>
                        </div>
                        {hasContactMessage && (
                          <div className="col-12">
                            <div className="bg-pink1">
                              <div className="messg">
                                {translation?.detailsSentRegisteredContact}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </section>
                </>
              )}
              <section className="myorder_main_section">
                <div className="container">
                  <div className="row justify-content-center">
                    <div
                      className={`orders-container featured-gap ${isMobile ? "mobile-cards" : "desktop-cards"
                        }`}
                    >
                      {olderOrdersRedirectUrl && (
                        <div className="upgradedPlatform order-card">
                          <div class="card-content">
                            <div className="order-details">
                              <div className="order-info" onClick={() => setOpenInst(!openInst)}>
                                <h3 className="order-heading">{translation?.upgradedPlatformTitle}</h3>
                                {/* <i className="fa-solid fa-chevron-up" onClick={() => setOpenInst(!openInst)}></i> */}
                                <i className={`fa-solid ${openInst ? "fa-angle-down" : "fa-angle-up"}`} ></i>
                              </div>
                              {openInst && (
                                <div>
                                  <p>{translation?.upgradedPlatformMessage}</p>
                                  <a
                                    className="view-older-orders"
                                    href={olderOrdersRedirectUrl}
                                  >
                                    {translation?.viewOlderOrders}
                                    <i className="fa-solid fa-long-arrow-up" ></i></a>
                                </div>
                              )}

                            </div>
                          </div>
                        </div>
                      )}

                      {userOrderData?.orderData &&
                        Array.isArray(userOrdersList) &&
                        [...userOrdersList].map((order, orderIndex) =>
                          order?.products?.map((product, index) => (
                            <div
                              className={`order-card ${clientDataReducer?.otpConfig === 2 &&
                                "height-310"
                                }`}
                              key={`${orderIndex}-${index}`}
                            >
                              <div className="card-content">
                                <div className="order_card_header">
                                  <div className="order-image">
                                    <img
                                      src={getImageUrl(product.image)}
                                      alt={product.name}
                                      onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = defaultImage;
                                      }}
                                    />
                                  </div>
                                  <div className="order-details">
                                    <h3 className="order-heading">{`${product.name} ₹ ${product.denomination} e-Gift-Card`}</h3>
                                    <div className="order_info_box">
                                      <div className="order-info1">
                                        <p className="order_labletext">
                                          {translation?.orderAmount}
                                        </p>
                                        <p className="order_valuebox">
                                          <span className="burnpointbox">
                                            {!isRewardStatusNotApplicable(
                                              getPointsRedeemStatus(order),
                                            ) && order.totalBurn > 0 &&
                                              `${order.totalBurn} Pts + `}
                                          </span>
                                          {!isRewardStatusNotApplicable(
                                            getPointsRedeemStatus(order),
                                          ) && order.totalBurn > 0 && (
                                            <span className="burnpointbox_withicon">
                                              <img
                                                src={pointiconImage}
                                                alt="point"
                                              />
                                              <span className="totalburnpoint_box">
                                                {Number(order.totalBurn).toLocaleString("en-IN")}
                                              </span>
                                              <span className="plussign">
                                                +
                                              </span>
                                            </span>
                                          )}
                                          <span>₹{formatPrice(order.amount)}</span>
                                        </p>
                                      </div>
                                      <div className="order-info1 quantity_box">
                                        <p className="order_labletext">
                                          {translation?.quantity}
                                        </p>
                                        <p className="order_valuebox">
                                          {product.qty}{" "}
                                          <span className="quantity_text">
                                            {translation?.myOrderCardQuantity ||
                                              translation?.quantity ||
                                              "Qty"}
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                    {showEarnLabelOnly &&
                                      !isRewardStatusNotApplicable(
                                        getPointEarnStatus(order),
                                      ) &&
                                      order?.orderStatus?.toLowerCase() !== "cancelled" &&
                                      !(
                                        !isRewardStatusNotApplicable(
                                          getPointsRedeemStatus(order),
                                        ) && Number(order.totalBurn) > 0
                                      ) &&
                                      Number(order.totalEarn) > 0 && (
                                        <div className="order-earned-row d-none">
                                          <span className="order-earned-label">
                                            {translation?.youHaveEarned ||
                                              "You've Earned"}
                                          </span>
                                          <span className="order-earned-total">
                                            <img
                                              src={pointiconImage}
                                              alt=""
                                              aria-hidden="true"
                                              className="order-earned-icon"
                                            />
                                            <span>
                                              {Math.round(
                                                Number(order.totalEarn),
                                              ).toLocaleString("en-IN")}
                                            </span>
                                          </span>
                                        </div>
                                      )}
                                  </div>
                                </div>
                                <div className="order-details2">
                                  <div className="order_info_box">
                                    <div className="order-info1">
                                      <p className="order_labletext">
                                        {translation?.orderNumber}
                                      </p>
                                      <p className="order_valuebox">
                                        {order.orderId}
                                      </p>
                                    </div>
                                    <div className="order-info1">
                                      <p className="order_labletext">
                                        {translation?.orderDate}
                                      </p>
                                      <p className="order_valuebox">
                                        {order.createdOn
                                          ? dateFormat(order.createdOn)
                                          : "Invalid Date"}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {order?.orderStatus === "Pending" ||
                                order?.orderStatus.toLowerCase() ===
                                "Cancelled".toLowerCase() ||
                                order?.orderStatus.toLowerCase() ===
                                "failed".toLowerCase() ? (
                                <button className="expired" disabled>
                                  {order?.orderStatus}
                                </button>
                              ) : (
                                <>
                                  {clientDataReducer?.otpConfig === 1 && (
                                    <div className="order-card-footer">
                                      <div className="btn-row right-align">
                                        {/* GET CODE */}
                                        <button
                                          className={`code-btn get-btn gradient_btn ${loadingCardKey ===
                                            `${orderIndex}-${index}-get`
                                            ? "loading"
                                            : ""
                                            }`}
                                          onClick={() =>
                                            handleRetrieveCode(
                                              product,
                                              order,
                                              `${orderIndex}-${index}-get`,
                                              "GET",
                                            )
                                          }
                                        >
                                          {loadingCardKey ===
                                            `${orderIndex}-${index}-get` ? (
                                            <span className="spinner-border spinner-border-sm"></span>
                                          ) : (
                                            translation?.retrieveCode
                                          )}
                                        </button>

                                        {/* RESEND CODE */}
                                        <button
                                          className={`code-btn resend-btn border_btn ${loadingCardKey ===
                                            `${orderIndex}-${index}-resend`
                                            ? "loading"
                                            : ""
                                            }`}
                                          onClick={() =>
                                            handleRetrieveCode(
                                              product,
                                              order,
                                              `${orderIndex}-${index}-resend`,
                                              "RESEND",
                                            )
                                          }
                                        >
                                          <span className="gradient_text_bronze">
                                            {loadingCardKey ===
                                              `${orderIndex}-${index}-resend` ? (
                                              <span className="spinner-border spinner-border-sm"></span>
                                            ) : (
                                              translation?.resendCode
                                            )}
                                          </span>
                                        </button>
                                      </div>
                                    </div>
                                  )}

                                  {clientDataReducer?.otpConfig === 2 && (
                                    <button
                                      className={`retrieve-btn resend-btn gradient_btn ${loadingCardKey ===
                                        `${orderIndex}-${index}-resend`
                                        ? "loading"
                                        : ""
                                        }`}
                                      onClick={() =>
                                        handleRetrieveCode(
                                          product,
                                          order,
                                          `${orderIndex}-${index}-resend`,
                                          "RESEND",
                                        )
                                      }
                                    >
                                      {loadingCardKey ===
                                        `${orderIndex}-${index}-resend` ? (
                                        <span className="spinner-border spinner-border-sm"></span>
                                      ) : (
                                        translation?.resendCode
                                      )}
                                    </button>
                                  )}
                                </>
                              )}
                            </div>
                          )),
                        )}
                    </div>
                  </div>
                </div>
              </section>
              {/* Loader/Observer element for infinite scroll */}
              {hasMore &&
                Array.isArray(userOrdersList) &&
                userOrdersList.length > 0 && (
                  <div
                    ref={loaderRef}
                    className="col-12 text-center py-4"
                    style={{ minHeight: "50px" }}
                  ></div>
                )}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default RetrieveCode;